// Copyright (c) Facebook, Inc. and its affiliates.
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core';


const styles = (theme) => ({
    title: {
        marginTop: '5em'
    },
    overview: {
        marginTop: '2em'
    },
    headings: {
        marginTop: '1em'
    },
    ulItems: {
        paddingLeft: '1.2em'
    },
    preParent: {
        backgroundColor: '#eee',
        border: '1px solid #ddd',
        borderRadius: '2px',
        '& pre': {
            whiteSpace: 'pre-wrap',
        },
        '& span': {
            padding: '1em',
        },
        '& code': {
            fontSize: '12px',
            color: '#000'
        }
    },
    evalAILink: {
        wordBreak: 'break-word'
    },
    teaserImage: {
        width: '100%',
    },
    spanTypography: {
        display: 'inline-block'
    },
    bannerLogo: {
        width: '100%'
    },
    sectionHeader: {
        marginTop: '0.35em'
    },
    evalaiLogo: {
        marginLeft: '-3px'
    }
});

const BestPractices = (props) => {
    return (
        <Grid
            container
            justify="center"
            alignItems="center"
        >
            <Grid
                item
                xs={10}
                md={8}
                lg={7}
            >
                <Grid
                    container
                    justify="flex-start"
                    alignItems="flex-start"
                    spacing={0}
                >
                    <Grid item className={props.classes.title} xs={12}>
                        <Typography variant="h3" align="left">
                            Best Practices
                        </Typography>
                    </Grid>
                    <Grid item className={props.classes.overview} xs={12}>

                        <Typography variant="subtitle1" className={props.classes.headings}  align="left">
                        Compared to COCO, LVIS evaluation metrics have higher variance. To provide a sense of this, 
                        we trained 50 Mask R-CNN (ResNet-50-FPN backbone with Repeat Factor Sampling) models on LVIS v1 train, varying only the random seed, and 
                        observed the following standard deviations on LVIS v1 val:
                        <ol>
                            <li> <b>AP</b> &nbsp;: 0.20 % (compared to 0.10% on COCO)</li>
                            <li> <b>AP<sub>r</sub></b> : 0.78 %</li>
                            <li> <b>AP<sub>c</sub></b> : 0.25 %</li>
                            <li> <b>AP<sub>f</sub></b> : 0.07 %</li>
                        </ol>
                        Given this variance, we recommend:
                        <ol>
                            <li> If possible, run each experiment multiple times with different seeds 
                                 and report the mean results with standard deviations.</li>
                            <li> A 1% (absolute) change may be significant for AP<sub>c</sub>, AP<sub>f</sub>, and AP, 
                                but <b>not</b> for AP<sub>r</sub>, due to the higher variance inherent in evaluating tail categories.</li>
                            <li>Please do not report the single best result from multiple runs (this result will 
                                be overfit and will not generalize).</li>
                            <li>Always specify your experimental protocol, including if you train multiple runs and 
                                if yes, how do you summarize the results (e.g. "we report the average of 5 runs").</li>
                        </ol>
                        Additional recommendations:
                        <ol>
                            <li>For papers, you can report key results on the <b>test-dev</b> set using the <Link href="https://evalai.cloudcv.org/web/challenges/challenge-page/675/overview">LVIS v1.0 Evaluation Server</Link>.</li>
                            <li>When training on LVIS, do not train on the union of the train and val sets. Only train on train to help keep results comparable between papers.</li>
                        </ol>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

      )
}

export default withStyles(styles)(BestPractices);
